import React from 'react';
import './assets/css/style.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home.jsx';

import MainHeader from './pages/MainHeader.jsx';
// import MainFooter from './pages/MainFooter.jsx';
import { ScrollToTop } from './pages/ScrollToTop.jsx';
import Profile from './pages/Profile.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';


function Layout({ children }) {
  return (
    <>
      <MainHeader />
      {children}
     
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
       <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout><Profile /></Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
